import React from 'react';

type TextVariant = 'h1' | 'h2' | 'h3' | 'body' | 'small' | 'muted';

type TextProps = {
  children: React.ReactNode;
  variant?: TextVariant;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
};

const variantClasses: Record<TextVariant, string> = {
  h1: 'font-display text-4xl md:text-5xl font-bold tracking-tight text-stone-900 dark:text-white',
  h2: 'font-display text-2xl md:text-3xl font-semibold text-stone-900 dark:text-stone-100',
  h3: 'font-display text-xl font-semibold text-stone-800 dark:text-stone-100',
  body: 'text-stone-700 leading-relaxed dark:text-stone-300',
  small: 'text-sm text-stone-600 dark:text-stone-400',
  muted: 'text-stone-500 text-sm dark:text-stone-400',
};

export function Text({
  children,
  variant = 'body',
  as: Component = 'p',
  className = '',
}: TextProps) {
  return (
    <Component className={`${variantClasses[variant]} ${className}`}>
      {children}
    </Component>
  );
}
